<template>
  <div style="display:none"></div>
</template>

<script>
import { batchDownloadFile } from "@/api/sysTem/userAdmin";

export default {
  name: "BatchFileDownload",
  methods: {
    async open(fileDicId, formConfigId, ids) {
      if (!Array.isArray(ids) || ids.length === 0) {
        this.$message({ type: "warning", message: "请选择要下载的数据" });
        return;
      }
      if (!fileDicId) {
        this.$message({ type: "warning", message: "未配置附件目录" });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在打包下载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await batchDownloadFile({ fileDicId, formConfigId, ids });
        const blob = response && response.data ? response.data : response;
        if (!blob) {
          this.$message.error("下载失败，未返回文件");
          return;
        }
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `${Date.now()}.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.error((e && e.message) || "批量下载失败");
      } finally {
        loading.close();
      }
    },
  },
};
</script>
